import { render, staticRenderFns } from "./PDFExportComponent.vue?vue&type=template&id=bb280f9c"
import script from "./PDFExportComponent.vue?vue&type=script&lang=js"
export * from "./PDFExportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports